/**
 * What the caller may do on a company, as decided by the gateway's `CompanyPolicy` (same enum as the
 * `permissions` field of `GET /v2/companies`). `create_project` is about creating a project in that company.
 */
export type CompanyPermission =
  | "view"
  | "edit"
  | "delete"
  | "manage_users"
  | "manage_checklists"
  | "create_project";

/** One company the caller can see, with the permissions they have on it. Read from `GET /v2/companies`. */
export class MyCompanyPermissions {
  constructor(
    public readonly companyId: string,
    public readonly permissions: CompanyPermission[],
  ) {}

  has(permission: CompanyPermission): boolean {
    return this.permissions.includes(permission);
  }

  static fromJson(json: any): MyCompanyPermissions {
    // `permissions` is missing on gateways older than the release that added it; treat that as no permissions
    // rather than crashing.
    return new MyCompanyPermissions(json["uuid"], json["permissions"] ?? []);
  }
}
